'use strict'

module.exports = function (el) {
  if (el == null) { return false; }

  const rect = el.getBoundingClientRect();

  return rect.top + rect.height - window.innerHeight < 0;
};